(function () {
  'use strict';

  var STYLE_ID = 'promo-categories-style';
  var NAV_CLASS = 'promo-categories';
  var COLLECTION_PATH = '/collections/promocoes';

  var CSS = [
    '.promo-categories{display:flex;gap:12px;margin-bottom:24px;flex-wrap:wrap;}',
    '.promo-category{box-sizing:border-box;display:flex;flex-direction:column;align-items:flex-start;justify-content:space-between;padding:20px;gap:12px;width:210px;height:147px;background:#ffffff;border:1px solid;border-radius:10px;text-decoration:none;color:#1a1a1a;cursor:pointer;transition:background-color .2s ease,border-color .2s ease,color .2s ease;}',
    '.promo-category__icon{display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:8px;transition:background-color .2s ease,color .2s ease;}',
    '.promo-category__icon svg{width:22px;height:22px;}',
    '.promo-category__title{font-weight:600;font-size:18px;line-height:1.2;}',
    '.promo-category__count{font-size:13px;color:#6b6b6b;transition:color .2s ease;}',
    '.promo-category:hover{color:#ffffff;}',
    '.promo-category:hover .promo-category__count{color:#ffffff;}',
    '.promo-category:hover .promo-category__icon{background:rgba(255,255,255,.2);color:#ffffff;}',
    '.promo-category.is-active{color:#ffffff;}',
    '.promo-category.is-active .promo-category__count{color:#ffffff;}',
    '.promo-category.is-active .promo-category__icon{background:rgba(255,255,255,.2);color:#ffffff;}',
    '.promo-category--whey{border-color:rgba(251,110,19,.25);}',
    '.promo-category--whey .promo-category__icon{color:#fb6e13;background:rgba(251,110,19,.12);}',
    '.promo-category--whey:hover,.promo-category--whey.is-active{background:#fb6e13;border-color:#fb6e13;}',
    '.promo-category--vegana{border-color:rgba(111,158,44,.25);}',
    '.promo-category--vegana .promo-category__icon{color:#6f9e2c;background:rgba(111,158,44,.12);}',
    '.promo-category--vegana:hover,.promo-category--vegana.is-active{background:#6f9e2c;border-color:#6f9e2c;}',
    '.promo-category--beef{border-color:rgba(155,44,44,.25);}',
    '.promo-category--beef .promo-category__icon{color:#9b2c2c;background:rgba(155,44,44,.12);}',
    '.promo-category--beef:hover,.promo-category--beef.is-active{background:#9b2c2c;border-color:#9b2c2c;}',
    '@media screen and (max-width:749px){',
    '.promo-categories{flex-wrap:nowrap;overflow-x:auto;-webkit-overflow-scrolling:touch;padding-bottom:4px;}',
    '.promo-category{flex:0 0 auto;width:150px;height:auto;padding:14px;}',
    '.promo-category__title{font-size:15px;}',
    '}'
  ].join('');

  var ICON_WHEY =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M9 2h6v3H9z" fill="currentColor"/>' +
    '<rect x="6.5" y="5" width="11" height="17" rx="2.5" stroke="currentColor" stroke-width="2"/>' +
    '<path d="M6.5 11h11" stroke="currentColor" stroke-width="2"/></svg>';

  var ICON_VEGANA =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M12 22V10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
    '<path d="M12 11C12 6 15 3 21 3C21 9 18 12 12 11Z" fill="currentColor"/>' +
    '<path d="M12 15C12 11 9.5 9 5 9C5 14 7.5 16 12 15Z" fill="currentColor"/></svg>';

  var ICON_BEEF =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M4.5 9.5C4.5 6 8 4 12 4C16.5 4 19.5 6.5 19.5 10.5C19.5 15 16 18 11 18C6.5 18 4.5 15.5 4.5 12.5C4.5 11.2 3 11 3 9.5C3 8.4 4 8.2 4.5 9.5Z" fill="currentColor"/>' +
    '<circle cx="14" cy="11" r="2" fill="currentColor" fill-opacity="0.45"/></svg>';

  // Termo procurado no titulo do produto. Edite aqui se algum nome mudar.
  var CATEGORIES = [
    { mod: 'whey', title: 'Whey Protein', count: '4 produtos', match: 'whey protein', icon: ICON_WHEY },
    { mod: 'vegana', title: 'Proteína Vegana', count: '3 produtos', match: 'true vegan', icon: ICON_VEGANA },
    { mod: 'beef', title: 'Beef Protein', count: '2 produtos', match: 'beef protein', icon: ICON_BEEF }
  ];

  var allItemsCache = null;
  var originalGridHTML = null;
  var activeMod = null;
  var isLoading = false;

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function getSectionId() {
    var grid = document.getElementById('product-grid');
    return grid ? grid.getAttribute('data-id') : null;
  }

  function getPagination() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return null;
    return container.querySelector('.pagination, nav[class*="pagination"], [class*="pagination__"]');
  }

  // Carrega todas as paginas da colecao via Section Rendering API e cacheia os grid__item.
  function loadAllItems() {
    if (allItemsCache) return Promise.resolve(allItemsCache);

    var sectionId = getSectionId();
    if (!sectionId) return Promise.resolve(currentDomItems());

    var items = [];

    function fetchPage(page) {
      var url = COLLECTION_PATH + '?section_id=' + encodeURIComponent(sectionId) + '&page=' + page;
      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var pageItems = doc.querySelectorAll('#product-grid .grid__item');
          if (pageItems.length === 0 || page > 20) {
            return items;
          }
          pageItems.forEach(function (el) { items.push(el); });
          return fetchPage(page + 1);
        });
    }

    return fetchPage(1)
      .then(function () {
        allItemsCache = items.length ? items : currentDomItems();
        return allItemsCache;
      })
      .catch(function () {
        return currentDomItems();
      });
  }

  function currentDomItems() {
    var grid = document.getElementById('product-grid');
    if (!grid) return [];
    return Array.prototype.slice.call(grid.querySelectorAll('.grid__item'));
  }

  function applyFilter(mod, match) {
    var grid = document.getElementById('product-grid');
    if (!grid || isLoading) return;

    if (originalGridHTML === null) {
      originalGridHTML = grid.innerHTML;
    }

    isLoading = true;

    loadAllItems().then(function (items) {
      var filtered = items.filter(function (el) {
        var heading = el.querySelector('.card__heading');
        var text = heading ? heading.textContent.toLowerCase() : '';
        return text.indexOf(match) !== -1;
      });

      grid.innerHTML = '';
      filtered.forEach(function (el) { grid.appendChild(el.cloneNode(true)); });

      var pag = getPagination();
      if (pag) pag.style.display = 'none';

      activeMod = mod;
      updateActiveState();
      isLoading = false;
    });
  }

  function clearFilter() {
    var grid = document.getElementById('product-grid');
    if (grid && originalGridHTML !== null) {
      grid.innerHTML = originalGridHTML;
    }
    var pag = getPagination();
    if (pag) pag.style.display = '';
    activeMod = null;
    updateActiveState();
  }

  function updateActiveState() {
    var links = document.querySelectorAll('.promo-category');
    links.forEach(function (l) {
      if (l.getAttribute('data-mod') === activeMod) {
        l.classList.add('is-active');
      } else {
        l.classList.remove('is-active');
      }
    });
  }

  function buildNav() {
    var nav = document.createElement('nav');
    nav.className = NAV_CLASS;
    nav.setAttribute('aria-label', 'Categorias em promoção');

    CATEGORIES.forEach(function (cat) {
      var a = document.createElement('a');
      a.className = 'promo-category promo-category--' + cat.mod;
      a.href = '#';
      a.setAttribute('data-mod', cat.mod);
      a.setAttribute('role', 'button');
      a.innerHTML =
        '<span class="promo-category__icon" aria-hidden="true">' + cat.icon + '</span>' +
        '<span class="promo-category__title">' + cat.title + '</span>' +
        '<span class="promo-category__count">' + cat.count + '</span>';

      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (activeMod === cat.mod) {
          clearFilter();
        } else {
          applyFilter(cat.mod, cat.match);
        }
      });

      nav.appendChild(a);
    });

    return nav;
  }

  function render() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    if (container.querySelector('.' + NAV_CLASS)) return;

    var grid = container.querySelector('.collection');
    var nav = buildNav();

    if (grid) {
      container.insertBefore(nav, grid);
    } else {
      container.insertBefore(nav, container.firstChild);
    }
  }

  function init() {
    injectStyle();
    render();

    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    // facets.js re-renderiza o container ao aplicar filtro nativo. Reinjeta a faixa.
    var observer = new MutationObserver(function () {
      if (!container.querySelector('.' + NAV_CLASS)) {
        activeMod = null;
        originalGridHTML = null;
        render();
      }
    });
    observer.observe(container, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();